import { render, staticRenderFns } from "./ZoneDeliveryRate.vue?vue&type=template&id=23fdf27b"
import script from "./ZoneDeliveryRate.vue?vue&type=script&lang=js"
export * from "./ZoneDeliveryRate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports